import { IBenefitsStore } from "./index";
import { benefits } from "../../steps";

export default {
  benefits: benefits,
  stepBenefits: [],
  summary: [],
  uniqueBenefits: [],
} as IBenefitsStore;
